
import React,{useState,useEffect} from 'react'
import HeaderofAdash from '../subComponent/HeaderofAdash'
import SidebarOfAdash from '../subComponent/SidebarOfAdash'
import {Row,Col,Modal,Form} from 'react-bootstrap'
import {AiOutlinePlus} from 'react-icons/ai'
import Dropdown2 from '../../subComponents/CustomSubComponents/Dropdown2'
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import axios from 'axios';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import TextField from '@mui/material/TextField';
import ReactPaginate from 'react-paginate';
import {optionsSubject, optionscheckedby, optionsinfotype, optionsnoticefor, optionsnoticetype, optionspublish, optionssection, optionssession, optionstailor, roledrp } from '../../Helper'
import moment from 'moment'
import { EditorState, convertToRaw,ContentState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import '../../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';



import { newsApi } from '../../../utils/AdminDashApi/NewsApi'
import { noticeAdminApi } from '../../../utils/AdminDashApi/NoticeAdminApi'
const NoticeCompAdmb = () => {
    const [editorState, setEditorState] = useState(EditorState.createEmpty());
    const [editorStatemod2, setEditorStatemod2] = useState(EditorState.createEmpty());

    const onEditorStateChange = (newEditorState) => {
      setEditorState(newEditorState);
      
      
    };
    const onEditorStateChangemod2 = (newEditorState) => {
      setEditorStatemod2(newEditorState);
      
      
    };
    const [editorState3, setEditorState3] = useState(EditorState.createEmpty());

    const onEditorStateChange3 = (newEditorState) => {
      setEditorState3(newEditorState);
      
    };
  

  const [activefrom,setactivefrom] = useState("")  
  const [activeto,setactiveTo] = useState("")
  const [activefrom2,setactivefrom2] = useState("")
  const [activeto2,setactiveTo2] = useState("")
  const [show,setShow] = useState(10)
  const [show2,setShow2] = useState("")
  const [noticetype,setnoticetype] = useState("")
  const [noticetype2,setnoticetype2] = useState("")

  const [activefromModal2label,setactivefromModal2label] = useState("")
  const [activefromModal2err,setactivefromModal2err] = useState("")
  
 const [activetoModal2err,setactivetoModal2err] = useState("")
 
  const handleShow = () => setShow2(true);
 
  const [newArr,setNewArr] = useState([])
  const [classresponse, setclassresponse] = useState([]);
  const headers = {
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Headers": "*",
    "Access-Control-Allow-Methods": "*",
}
  useEffect(() => {
    const fetchClassDropdown = async () => {
        try {
            const classresponse = await axios.get(
                "https://sass.britishstandardschool.com/api/Public/ClassList",
                {},
                headers
            );
            setclassresponse(classresponse.data);
            // console.log(classresponse);
        } catch (err) {
            if (err.classresponse) {
                console.error(err.classresponse.data);
                console.log(err.classresponse.status);
                console.log(err.classresponse.header);
            } else {
                console.error(`Error: ${err.message}`);
            }
        }
    };
    fetchClassDropdown();
}, []);
  const optionsShowt = [
    {
      id:0,
      opt:"Select"
    }
    ,{
      id:1,
      opt:10
    },
    {
      id:2,
      opt:20
    },
    {
      id:3,
      opt:30
    },
  ]
  const [mainpagesearch,setmainpagesearch] = useState("")
  const handlemainpagesearch=(e)=>{
    setmainpagesearch(e.target.value)
  }
  const [statusvalueerr,setstatusvalueerr] = useState("")
  const [activefromMoment,setactivefromMoment] = useState("")

  useEffect(()=>{
    var date = moment("2017-07-11")
      var now = moment("2020-07-12");

      if (now > date) {
        console.log("past")
      } else {
        console.log("future")
      }
  },[])
  const [classdrp,setClassdrp] = useState("")
  
  const drpfuncClass=(myval,myid)=>{
    setClassdrp(myid)    
  }
    
  

   

    const [show3, setShow3] = useState(false);

    const handleClose2=()=>{
      setShow3(false)
    }
    const [modalitem,setmodalitem] = useState(null)
    const handleShow3 = (e,myitem) =>{
      setShow3(true)
      setmodalitem(myitem)
      
      
    };
    const handleClosemenumodal= ()=>{
      setShow3(false)
    }
  const [currentItems, setCurrentItems] = useState([]);
  const [currentItemsmodel, setCurrentItemsmodel] = useState(null);
  const [pageCount, setPageCount] = useState(0);
  const [pageCountfiltered, setPageCountfiltered] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const [itemOffsetfiltered, setItemOffsetfiltered] = useState(0);
  const [itemsPerPage,setitemsPerPage] = useState(10);
  const [paginatenumselected,setpaginatenumselected] = useState(0)
  const [paginatenumselectedfiltered,setpaginatenumselectedfiltered] = useState(0)
  const [pageCount2, setPageCount2] = useState(0);
  const [itemOffset2, setItemOffset2] = useState(0);
  const [itemsPerPage2,setitemsPerPage2] = useState(10);
  
  const [itemsPerPagefiltered,setitemsPerPagefiltered] = useState(10);
  const [paginatenumselected2,setpaginatenumselected2] = useState(0)
  const [filteredArr,setfilteredArr] = useState(noticeAdminApi.data)


  const mainfilter=(searchkey,arr)=>{    
    
    let filteredArr = [];


    if (searchkey) {
        filteredArr = arr.filter((item) => {
          
          const searchMatch = item.subjectname.toLowerCase().includes(searchkey.toLowerCase());
          return searchMatch;
        });
      
      
      } else  {
        filteredArr = arr.filter((item) => {
          return item;
        });
      }

setfilteredArr(filteredArr);
    
  }



  const [tempfilteredarr,settempfilteredarr] = useState([])
    useEffect(() => {
        // Fetch items from another resources.
        const endOffset = itemOffset + itemsPerPage;        
        setCurrentItems(noticeAdminApi.data.slice(itemOffset, endOffset));        
        setPageCount(Math.ceil(noticeAdminApi.data.length / itemsPerPage));
        
      }, [itemOffset, itemsPerPage]);
      let [pagecountoffilter,setpagecountoffilter] = useState(filteredArr.length)
      useEffect(()=>{
        const endOffsetfiltered = itemOffsetfiltered + itemsPerPagefiltered;
        settempfilteredarr(filteredArr.slice(itemOffsetfiltered, endOffsetfiltered));
        setPageCountfiltered(Math.ceil(pagecountoffilter / itemsPerPagefiltered));
        setpagecountoffilter(filteredArr.length)
      },[itemOffsetfiltered,itemsPerPagefiltered,filteredArr,tempfilteredarr])
    
      // Invoke when user click to request another page.
      const handlePageClick = (event) => {
        const newOffset = event.selected * itemsPerPage % noticeAdminApi.data.length;        
        setpaginatenumselected(event.selected);
        setItemOffset(newOffset);
      };
      const handlePageClickfiltered = (event) => {
        const newOffsetf = event.selected * itemsPerPagefiltered % pagecountoffilter;        
        setpaginatenumselectedfiltered(event.selected);
        setItemOffsetfiltered(newOffsetf);
      };
    
      const handleClose=()=>{
        setShow2(false)
      }
   
      const [classmod1err,setclassmod1err] = useState("")
      const [classmod2err,setclassmod2err] = useState("")

      const [myclassmod2,setmyclassmod2] = useState("")
      const [labelmyclassmod2,setlabelmyclassmod2] = useState("")
    
    const [noticefor,setnoticefor] = useState("")
    const [noticeforerr,setnoticeforerr] = useState("")
    const [myclassmod2err,setmyclassmod2err] = useState("")
   
    const [noticefor2,setnoticefor2] = useState("")
    

      const drpfuncclassmod2 =(myval,myid)=>{
        setmyclassmod2(myval)
      }
      const drpfuncnoticetype =(myval,myid)=>{
        setnoticetype(myval)
      }
      const drpfuncnoticetype2 =(myval,myid)=>{
        setnoticetype2(myval)
      }
      const drpfuncnoticefor2 =(myval,myid)=>{
        setnoticefor2(myval)
      }
      const drpfuncnoticefor =(myval,myid)=>{
        setnoticefor(myval)
      }
      
      const drpfuncinfotype2 =(myval,myid)=>{
        setinfotype2(myval)
      }
      
      const handlesearch =()=>{
    
        setactivefrom("")
      
    }

    

    const [searchinputmodal,setsearchinputmodal] = useState("")
    const [rolesearchkey,setrolesearchkey] = useState("")
    const handlesearchinputmodal=(e)=>{
      setsearchinputmodal(e.target.value)      
    }
    const handlesearchmodal=()=>{
      setrolesearchkey(searchinputmodal)
    }
    const drpfuncshow=(myshow,id)=>{
      setShow(myshow)
      
    }
    
    const [ischkmodal,setischkmodal] = useState(false)
    const handleChangechk = event => {
      if (event.target.checked) {
        console.log('✅ Checkbox is checked');
      } else {
        console.log('⛔️ Checkbox is NOT checked');
      }
      setischkmodal(current => !current);
    };
  

   
   

    useEffect(()=>{
      
        mainfilter(mainpagesearch,noticeAdminApi.data)      

      
    },[mainpagesearch])
    
    const handleActiveFrom = (activefromval)=>{

        if(activefromval != null){
          
            var dtmnt = activefromval.$M + 1;
            var dtfinalc = activefromval.$y + '-'+ dtmnt +'-'+ activefromval.$D;
           
            var tt = moment(dtfinalc,'YYYY-MM-DD').calendar() 
            console.log(tt - moment("2023-06-12",'YYYY-MM-DD').calendar())
            console.log(dtfinalc)
            setactivefrom(dtfinalc)
        }
        
        
    }
    const handlenoticedatemod1 = (activefromval)=>{

        if(activefromval != null){
          
            var dtmnt = activefromval.$M + 1;
            var dtfinalc = activefromval.$y + '-'+ dtmnt +'-'+ activefromval.$D;
           
            var tt = moment(dtfinalc,'YYYY-MM-DD').calendar() 
            console.log(tt - moment("2023-06-12",'YYYY-MM-DD').calendar())
            console.log(dtfinalc)
            setnoticedatemod1(dtfinalc)
        }
        
        
    }
    const handlenoticedatemod2 = (activefromval)=>{

        if(activefromval != null){
          
            var dtmnt = activefromval.$M + 1;
            var dtfinalc = activefromval.$y + '-'+ dtmnt +'-'+ activefromval.$D;
           
            var tt = moment(dtfinalc,'YYYY-MM-DD').calendar() 
            console.log(tt - moment("2023-06-12",'YYYY-MM-DD').calendar())
            console.log(dtfinalc)
            setnoticedatemod2(dtfinalc)
        }
        
        
    }
    const [activefromModal1,setactivefromModal1] = useState("")
    const handleActiveFromModal1 = (activefromval)=>{

        if(activefromval != null){
          
            var dtmnt = activefromval.$M + 1;
            var dtfinalc = activefromval.$y + '-'+ dtmnt +'-'+ activefromval.$D;
           
            var tt = moment(dtfinalc,'YYYY-MM-DD').calendar() 
            console.log(tt - moment("2023-06-12",'YYYY-MM-DD').calendar())
            console.log(dtfinalc)
            setactivefromModal1(dtfinalc)
        }
        
        
    }
      const handleActiveTo = (activetoval)=>{
    
        if(activetoval != null){
    
            var dtmnt = activetoval.$M + 1;
            var dtfinalc = activetoval.$y + '-'+ dtmnt +'-'+ activetoval.$D;
            var dd = moment(activeto,'YYYY-MM-DD').calendar() - moment(dtfinalc,'YYYY-MM-DD').calendar() 
            setactiveTo(dtfinalc)

            
        }
        
        
    }
    const [activetoModal1,setactivetoModal1] = useState("")
      const handleActivetoModal1 = (activetoval)=>{
    
        if(activetoval != null){
    
            var dtmnt = activetoval.$M + 1;
            var dtfinalc = activetoval.$y + '-'+ dtmnt +'-'+ activetoval.$D;
            var dd = moment(activeto,'YYYY-MM-DD').calendar() - moment(dtfinalc,'YYYY-MM-DD').calendar() 
            setactivetoModal1(dtfinalc)

            
        }
        
        
    }
    
   
    // Modal2activefromto 
    
    const handleActiveFrom2 = (activefromval)=>{

        if(activefromval != null){
          
            var dtmnt = activefromval.$M + 1;
            var dtfinalc = activefromval.$y + '-'+ dtmnt +'-'+ activefromval.$D;
           
            var tt = moment(dtfinalc,'YYYY-MM-DD').calendar() 
            console.log(tt - moment("2023-06-12",'YYYY-MM-DD').calendar())
            console.log(dtfinalc)
            setactivefrom2(dtfinalc)
        }
        
        
    }
    const [activefromModal2,setactivefromModal2] = useState("")
    const handleActiveFromModal2 = (activefromval)=>{

        if(activefromval != null){
          
            var dtmnt = activefromval.$M + 1;
            var dtfinalc = activefromval.$y + '-'+ dtmnt +'-'+ activefromval.$D;
           
            var tt = moment(dtfinalc,'YYYY-MM-DD').calendar() 
            console.log(tt - moment("2023-06-12",'YYYY-MM-DD').calendar())
            console.log(dtfinalc)
            setactivefromModal2(dtfinalc)
        }
        
        
    }
      const handleActiveTo2 = (activetoval)=>{
    
        if(activetoval != null){
    
            var dtmnt = activetoval.$M + 1;
            var dtfinalc = activetoval.$y + '-'+ dtmnt +'-'+ activetoval.$D;
            var dd = moment(activeto,'YYYY-MM-DD').calendar() - moment(dtfinalc,'YYYY-MM-DD').calendar() 
            setactiveTo2(dtfinalc)

            
        }
        
        
    }

    const [activetoModal2,setactivetoModal2] = useState("")
    const [activetoModal2label,setactivetoModal2label] = useState("")

      const handleActiveToModal2 = (activetoval)=>{
    
        if(activetoval != null){
    
            var dtmnt = activetoval.$M + 1;
            var dtfinalc = activetoval.$y + '-'+ dtmnt +'-'+ activetoval.$D;
            var dd = moment(activeto,'YYYY-MM-DD').calendar() - moment(dtfinalc,'YYYY-MM-DD').calendar() 
            setactivetoModal2(dtfinalc)

            
        }
        
        
    }
    

   



     
    const [activefromModal1label,setactivefromModal1label] = useState("")
    const [activetoModal1label,setactivetoModal1label] = useState("")
     
    const [activefromModal1err,setactivefromModal1err] = useState("")
    const [activetoModal1err,setactivetoModal1err] = useState("")
   
 
    

    const [infotype,setinfotype] = useState("")
    const [noticetypeerr,setnoticetypeerr] = useState("")
    const [noticetypelabel,setnoticetypelabel] = useState("")
    
    
    const [noticetypeerr2,setnoticetypeerr2] = useState("")
    const [noticetypelabel2,setnoticetypelabel2] = useState("")
    
    const [noticeforerr2,setnoticeforerr2] = useState("")
    const [noticeforlabel2,setnoticeforlabel2] = useState("")
    
    const [noticeforlabel,setnoticeforlabel] = useState("")
    
    const [infotype2,setinfotype2] = useState("")
    const [infotypeerr2,setinfotypeerr2] = useState("")
    const [infotypelabel2,setinfotypelabel2] = useState("")
 
    
    const [schoolidmod1eerr,setschoolidmod1err] = useState("")
    const [schoolidmod1label,setschoolidmod1label] = useState("")
    
    const [schoolidmod2eerr,setschoolidmod2err] = useState("")
    const [schoolidmod2label,setschoolidmod2label] = useState("")

    const [descriptionmod1err,setdescriptionmod1err] = useState("")
    const [descriptionmod1label,setdescriptionmod1label] = useState("")
    
    const [descriptionmod2err,setdescriptionmod2err] = useState("")
    const [descriptionmod2label,setdescriptionmod2label] = useState("")
    

    const [myclass,setclass] = useState("")
    const [myclasserr,setmyclasserr] = useState("")
    const [labelmyclass,setlabelmyclass] = useState("")
    
    
    
   
   
    const [section,setsection] = useState("")
    const [sectionerr,setsectionerr] = useState("")
    const [labelsection,setlabelsection] = useState("")
    
    const [sectionmod2,setsectionmod2] = useState("")
    const [sectionerrmod2,setsectionerrmod2] = useState("")
    const [labelsectionmod2,setlabelsectionmod2] = useState("")
    
    const [shift,setshift] = useState("")
    const [shifterr,setshifterr] = useState("")
    const [labelshift,setlabelshift] = useState("")
    
    const [shiftmod2,setshiftmod2] = useState("")
    const [shifterrmod2,setshifterrmod2] = useState("")
    const [labelshiftmod2,setlabelshiftmod2] = useState("")
    
    const [titlemod1,settitlemod1] = useState("")
    const [titlemod1err,settitlemod1err] = useState("")
    const [labeltitlemod1,setlabeltitlemod1] = useState("")
    
    const [titlemod2,settitlemod2] = useState("")
    const [titlemod2err,settitlemod2err] = useState("")
    const [labeltitlemod2,setlabeltitlemod2] = useState("")

    const [publishmod1,setpublishmod1] = useState("")
    const [publishmod1err,setpublishmod1err] = useState("")
    const [labelpublishmod1,setlabelpublishmod1] = useState("")

    const [publishmod2,setpublishmod2] = useState("")
    const [publishmod2err,setpublishmod2err] = useState("")
    const [labelpublishmod2,setlabelpublishmod2] = useState("")

    const [tailormod1,settailormod1] = useState("")
    const [tailormod1err,settailormod1err] = useState("")
    const [labeltailormod1,setlabeltailormod1] = useState("")
    
    const [tailormod2,settailormod2] = useState("")
    const [tailormod2err,settailormod2err] = useState("")
    const [labeltailormod2,setlabeltailormod2] = useState("")

    const [checkedbymod1,setcheckedbymod1] = useState("")
    const [checkedbymod1err,setcheckedbymod1err] = useState("")
    const [labelcheckedbymod1,setlabelcheckedbymod1] = useState("")
    
    const [checkedbymod2,setcheckedbymod2] = useState("")
    const [checkedbymod2err,setcheckedbymod2err] = useState("")
    const [labelcheckedbymod2,setlabelcheckedbymod2] = useState("")


    const [orderedbymod1,setorderedbymod1] = useState("")
    const [orderedbymod1err,setorderedbymod1err] = useState("")
    const [labelorderedbymod1,setlabelorderedbymod1] = useState("")
    
    const [orderedbymod2,setorderedbymod2] = useState("")
    const [orderedbymod2err,setorderedbymod2err] = useState("")
    const [labelorderedbymod2,setlabelorderedbymod2] = useState("")

    const [sessionmod1,setsessionmod1] = useState("")
    const [sessionmod1err,setsessionmod1err] = useState("")
    const [labelsessionmod1,setlabelsessionmod1] = useState("")
    
    const [sessionmod2,setsessionmod2] = useState("")
    const [sessionmod2err,setsessionmod2err] = useState("")
    const [labelsessionmod2,setlabelsessionmod2] = useState("")

    const [noticedatemod1,setnoticedatemod1] = useState("")
    const [noticedatemod1err,setnoticedatemod1err] = useState("")
    const [labelnoticedatemod1,setlabelnoticedatemod1] = useState("")
    const [noticedatemod2,setnoticedatemod2] = useState("")
    const [noticedatemod2err,setnoticedatemod2err] = useState("")
    const [labelnoticedatemod2,setlabelnoticedatemod2] = useState("")



    const [sectionmod2err,setsectionmod2err] = useState("")

    const [shiftmod2err,setshiftmod2err] = useState("")
    const drpfuncsection=(myval,myid)=>{
        setsection(myid)
    }
    const drpfuncsectionmod2=(myval,myid)=>{
        setsectionmod2(myid)
    }
    const drpfuncshift=(myval,myid)=>{
        setshift(myid)
    }
    
    const drpfuncshiftmod2=(myval,myid)=>{
        setshiftmod2(myid)
    }
    
    const handletitlemod1=(e)=>{
        settitlemod1(e.target.value)
    }
    const handletitlemod2=(e)=>{
        settitlemod2(e.target.value)
    }
    const handlepublishmod1=(myval,myid)=>{
        setpublishmod1(myid)
    }
    const handlepublishmod2=(myval,myid)=>{
        setpublishmod2(myid)
    }
    const handletailormod1=(myval,myid)=>{
        settailormod1(myid)
    }
    const handletailormod2=(myval,myid)=>{
        settailormod2(myid)
    }
    const handlecheckedbymod1=(myval,myid)=>{
        setcheckedbymod1(myid)
    }
    const handlecheckedbymod2=(myval,myid)=>{
        setcheckedbymod2(myid)
    }
    const handleorderedbymod1=(myval,myid)=>{
        setorderedbymod1(myid)
    }
    const handleorderedbymod2=(myval,myid)=>{
        setorderedbymod2(myid)
    }
    const handlesessionmod1=(myval,myid)=>{
        setsessionmod1(myid)
    }
    const handlesessionmod2=(myval,myid)=>{
        setsessionmod2(myid)
    }

    const [editorState2,seteditorState2] = useState(null)
    const [editorState4,seteditorState4] = useState(null)
    // Validation 

    const handlesaveModal1 = ()=>{
      
      
      seteditorState2(draftToHtml(convertToRaw(editorState.getCurrentContent())))
      
      
      if(activefromModal1.length==0){
        setactivefromModal1label("Active From Required")
        setactivefromModal1err("err")
      }else{
        setactivefromModal1label("")
        setactivefromModal1err("")
      }
      if(noticedatemod1.length==0){
        setlabelnoticedatemod1("Notice Date Required")
        setnoticedatemod1err("err")
      }else{
        setlabelnoticedatemod1("")
        setnoticedatemod1err("")
      }
     
      if(activetoModal1.length==0){
        setactivetoModal1label("Active From Required")
        setactivetoModal1err("err")
      }else{
        setactivetoModal1label("")
        setactivetoModal1err("")
      }
      
      if(section==""){
        setlabelsection("Seciton required")
        setsectionerr("err")
      }else{
        setlabelsection("")
        setsectionerr("")
      }
      if(shift==""){
        setlabelshift("Shift required")
        setshifterr("err")
      }else{
        setlabelshift("")
        setshifterr("")
      }
      if(classdrp.length==0){
        setlabelmyclass("Class required")
        setmyclasserr("err")
      }else{
        setlabelmyclass("")
        setmyclasserr("")
      }
      if(noticetype==""){
        setnoticetypelabel("Notice Type required")
        setnoticetypeerr("err")
      }else{
        setnoticetypelabel("")
        setnoticetypeerr("")
      }
      if(noticefor==""){
        setnoticeforlabel("Notice for required")
        setnoticeforerr("err")
      }else{
        setnoticeforlabel("")
        setnoticeforerr("")
      }
      if(titlemod1==""){
        setlabeltitlemod1("Title required")
        settitlemod1err("err")
      }else{
        setlabeltitlemod1("")
        settitlemod1err("")
      }
      if(publishmod1.length==0){
        setlabelpublishmod1("Publish required")
        setpublishmod1err("err")
      }else{
        setlabelpublishmod1("")
        setpublishmod1err("")
      }
      if(tailormod1.length==0){
        setlabeltailormod1("Tailor required")
        settailormod1err("err")
      }else{
        setlabeltailormod1("")
        settailormod1err("")
      }
      if(checkedbymod1==""){
        setlabelcheckedbymod1("Checked By required")
        setcheckedbymod1err("err")
      }else{
        setlabelcheckedbymod1("")
        setcheckedbymod1err("")
      }
     if(editorState2==null || editorState2==""){
      setdescriptionmod1err("err")
      setdescriptionmod1label("Html Body Required")
     }else{
      setdescriptionmod1err("")
      setdescriptionmod1label("")
      
     }
     if(orderedbymod1==""){
        setlabelorderedbymod1("Ordered By required")
        setorderedbymod1err("err")
      }else{
        setlabelorderedbymod1("")
        setorderedbymod1err("")
      }
      if(sessionmod1==""){
        setlabelsessionmod1("Session required")
        setsessionmod1err("err")
      }else{
        setlabelsessionmod1("")
        setsessionmod1err("")
      }
     
    //   if(newsTitleMod1!=="" &&
      
      
    //   activefromModal1.length!==0 &&      
    //   activeToModal1.length!==0
    //     ){
    //       console.log("Done")
    //       setShow2(false)
    //       setNewArr([...filteredArr,{
    //         newstitle:newsTitleMod1,
              
    //         description: descriptionMod1,      
    //         activeFrom:activefromModal1,
    //         activeTo:activeToModal1

    //       }])
    //     }

        

    }
   
   useEffect(()=>{
  
    editorState.getCurrentContent()
   },[editorState2])

  
    
   
    const handlesaveModal2 = ()=>{
      
      seteditorState4(draftToHtml(convertToRaw(editorStatemod2.getCurrentContent())))
      
      if(activetoModal2.length==0){
        setactivetoModal2label("Active From Required")
        setactivetoModal2err("err")
      }else{
        setactivetoModal2label("")
        setactivetoModal2err("")
      }
      if(activefromModal2.length==0){
        setactivefromModal2label("Active From Required")
        setactivefromModal2err("err")
      }else{
        setactivefromModal2label("")
        setactivefromModal2err("")
      }
      if(noticedatemod2.length==0){
        setlabelnoticedatemod2("Notice Date Required")
        setnoticedatemod2err("err")
      }else{
        setlabelnoticedatemod2("")
        setnoticedatemod2err("")
      }
     
     
      
      if(sectionmod2==""){
        setlabelsectionmod2("Seciton required")
        setsectionmod2err("err")
      }else{
        setlabelsectionmod2("")
        setsectionmod2err("")
      }
      if(shiftmod2==""){
        setlabelshiftmod2("shiftmod2 required")
        setshifterrmod2("err")
      }else{
        setlabelshiftmod2("")
        setshifterrmod2("")
      }
      if(myclassmod2==""){
        setlabelmyclassmod2("Class required")
        setclassmod2err("err")
      }else{
        setlabelmyclassmod2("")
        setclassmod2err("")
      }
      if(noticetype2==""){
        setnoticetypelabel2("Notice Type required")
        setnoticetypeerr2("err")
      }else{
        setnoticetypelabel2("")
        setnoticetypeerr2("")
      }
      if(noticefor2==""){
        setnoticeforlabel2("Notice for required")
        setnoticeforerr2("err")
      }else{
        setnoticeforlabel2("")
        setnoticeforerr2("")
      }
      if(titlemod2==""){
        setlabeltitlemod2("Title required")
        settitlemod2err("err")
      }else{
        setlabeltitlemod2("")
        settitlemod2err("")
      }
      if(publishmod2==""){
        setlabelpublishmod2("Publish required")
        setpublishmod2err("err")
      }else{
        setlabelpublishmod2("")
        setpublishmod2err("")
      }
      if(tailormod2==""){
        setlabeltailormod2("Tailor required")
        settailormod2err("err")
      }else{
        setlabeltailormod2("")
        settailormod2err("")
      }
      if(checkedbymod2==""){
        setlabelcheckedbymod2("Checked By required")
        setcheckedbymod2err("err")
      }else{
        setlabelcheckedbymod2("")
        setcheckedbymod2err("")
      }
     if(editorState4==null){
      setdescriptionmod2err("err")
      setdescriptionmod2label("Html Body Required")
      
     }else{
      setdescriptionmod2err("")
      setdescriptionmod2label("")
      
      
     }
     if(orderedbymod2==""){
        setlabelorderedbymod2("Ordered By required")
        setorderedbymod2err("err")
      }else{
        setlabelorderedbymod2("")
        setorderedbymod2err("")
      }
      if(sessionmod2==""){
        setlabelsessionmod2("Session required")
        setsessionmod2err("err")
      }else{
        setlabelsessionmod2("")
        setsessionmod2err("")
      }
    

    }
    const handleClose3=()=>{
      setShow3(false)
    }
    

   

    


    // start
  return (
    <>
    <div className="felxvaluecompmbmain">
        <div className="studentdashboardmobilewrapper">
            <div className="mobilecontainer">
                <div className="adminmbheading">
                    <h3>Notice</h3>
                </div>
                <div className="admbwrap bt0">
                    <Row>
                        <Col xs={12}>
                        <div className="basicinput">                            
                            <button className='cmbutton' onClick={handleShow}> <AiOutlinePlus />New Notice</button>
                        </div>
                        </Col>
                        <Col xs={6} className="pr5">
                        <div className="basicinput">
                            <p>Active from</p>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                
                                value={activefrom}
                                onChange={(newvaldob)=>handleActiveFrom(newvaldob)}
                                renderInput={(params) => <TextField {...params}inputProps={{
                                    ...params.inputProps,
                                    placeholder: "Active From"
                                    }} error={false} />}
                            />
                            </LocalizationProvider>
                        </div>
                        </Col>
                        <Col xs={6} className="pl5">
                        <div className="basicinput">
                            <p>Active To</p>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                
                                value={activeto}
                                onChange={(newvaldob)=>handleActiveTo(newvaldob)}
                                renderInput={(params) => <TextField {...params}inputProps={{
                                    ...params.inputProps,
                                    placeholder: "Active To"
                                    }} error={false} />}
                            />
                            </LocalizationProvider>
                        </div>
                        </Col>
                    </Row>
                </div>
                <div className="admbwrap pb0">
                <Row>
                    <Col lg={3} xs={4} className="pr5">
                    <div className="basicinput">
                      <p>Show</p>
                      <div className="dropdownwrapper">
                        
                          <Dropdown2 func={drpfuncshow} myplaceholder="Select" fontsize="16" fontfamily="'Poppins', sans-serif"  options={optionsShowt}/>
                      </div>
                      </div>
                    </Col>
                    <Col lg={9}  xs={8} className="pl5">
                            <div className="basicinput">
                              <p>Search</p>
                              <div className="wrap">
                              <input type="text" placeholder="Search" value={mainpagesearch} onChange={handlemainpagesearch}/>
                              <img src="./assets/images/dashboards/adminDashboard/flexvalue/search.png" alt="" />

                              </div>
                            </div>
                    </Col>
                  </Row>
                </div>
                <div className="admbwrap">
                    <div className="tablewrapscroll">
                    <div className="flexvaluetable noticeadmindtable">
                    <table>
                      <thead>
                        <tr>
                            {
                              noticeAdminApi.heading.map((item,key)=>{
                                return(
                                  <th key={key}> <div>{item.head}</div> </th>
                                )
                              })
                            }
                        </tr>
                      </thead>
                      {
                        // mainpagesearch==""?
                          <tbody>
                          {
                            filteredArr.length!==0?
                          

                            tempfilteredarr.map((item,key)=>{
                              return(
                                <tr key={key}>
                                  {/* <td>{editorState2!==null?<div dangerouslySetInnerHTML={{ __html: editorState2 }} />:item.description}</td> */}
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  
                                  <td>
                                    <div className="img text-center">
                                      <img onClick={(e)=> handleShow3(e,item)} src={item.action} alt="" />  
                                    </div>  
                                  </td>
                                </tr>
                              )
                            })
                            :
                            ""
                         
                          }
                        </tbody>                        
                      }
                       
                    </table>
                  </div>
                    </div>
                </div>
                <div className="admbwrap">
                <Row>
                <Col lg={10} className="m-auto">
                    {
                      filteredArr.length!==0?
                  <Row>
                  <Col lg={6}>
                        <p className='pagileft text-center'>Showing {itemOffsetfiltered+1} to {itemOffsetfiltered+10} of {filteredArr.length} entries (filtered from 10 total entries)</p>
                  </Col>
                  <Col lg={6} className="ms-auto">
                    <div className="paginationwrapper">

                  <ReactPaginate
                      breakLabel="..."
                      nextLabel="next"
                      onPageChange={handlePageClickfiltered}
                      pageRangeDisplayed={2}
                      pageCount={pageCountfiltered}
                      previousLabel="prev"
                      renderOnZeroPageCount={null}
                      containerClassName='pagination'
                      pageLinkClassName='page-num'
                      previousLinkClassName='page-numl'
                      nextLinkClassName='page-numr'
                      activeLinkClassName='activelink'
                      disabledClassName="disabledClass"
                      
                    />
                    </div>
                  </Col>
                  </Row>
                      
                      :
                      
                  <Row>
                  <Col lg={6}>
                        <p className='pagileft text-center'>Showing {itemOffset+1} to {itemOffset+10} of {noticeAdminApi.data.length} entries (filtered from 10 total entries)</p>
                  </Col>
                  <Col lg={6} className="ms-auto">
                    <div className="paginationwrapper">

                  <ReactPaginate
                      breakLabel="..."
                      nextLabel="next"
                      onPageChange={handlePageClick}
                      pageRangeDisplayed={2}
                      pageCount={pageCount}
                      previousLabel="prev"
                      renderOnZeroPageCount={null}
                      containerClassName='pagination'
                      pageLinkClassName='page-num'
                      previousLinkClassName='page-numl'
                      nextLinkClassName='page-numr'
                      activeLinkClassName='activelink'
                      disabledClassName="disabledClass"
                      
                    />
                    </div>
                  </Col>
                  </Row>
                    }
                </Col>
               
              </Row>
                </div>
                {/* modal1ori */}

              <Modal dialogClassName="mymodal" show={show2} onHide={handleClose} backdrop="static"
              keyboard={false}>
               
                <Modal.Header closeButton>
                  <Modal.Title className="ms-auto">Notice</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <Row>
                    <Col lg={10} className="m-auto">
                    <Row>
                        <Col lg={4} xs={6} className="pr5">
                            <div className="basicinput">
                                <p>Notice Date</p>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <div className="inputgap h35p mbp">
                                        <DatePicker

                                            value={noticedatemod1}
                                            onChange={(newvaldob) => handlenoticedatemod1(newvaldob)}
                                            renderInput={(params) => <TextField style={noticedatemod1err == "err" ? { border: "1px solid #ed1c24", borderRadius: "10px" } : {}} {...params} inputProps={{
                                                ...params.inputProps,
                                                placeholder: " "
                                            }} error={false} />}
                                        />
                                        <label>{labelnoticedatemod1}</label>
                                    </div>
                                </LocalizationProvider>
                            </div>
                        </Col>
                        <Col lg={4} xs={6} className="pl5">
                        <div className="basicinput ">
                            <p>Notice Type</p>
                            <div className="inputgap h35p mbp">
                                <div className="dropdownwrapper">

                                    <Dropdown2 err={noticetypeerr == "err" ? "err" : ""} func={drpfuncnoticetype} myplaceholder=" " fontsize="16" fontfamily="'Poppins', sans-serif" options={optionsnoticetype} />
                                </div>
                                <label>{noticetypelabel}</label>
                            </div>
                        </div>
                        </Col>
                        <Col lg={4} xs={6} className='pr5'>
                        <div className="basicinput ">
                            <p>Notice For</p>
                            <div className="inputgap h35p mbp">
                                <div className="dropdownwrapper">

                                    <Dropdown2 err={noticeforerr == "err" ? "err" : ""} func={drpfuncnoticefor} myplaceholder=" " fontsize="16" fontfamily="'Poppins', sans-serif" options={optionsnoticefor} />
                                </div>
                                <label>{noticeforlabel}</label>
                            </div>
                        </div>
                        </Col>
                        <Col lg={4} xs={6} className='pl5'>
                        <div className="basicinput ">
                            <p>Class</p>
                            <div className="inputgap h35p mbp">
                                <div className="dropdownwrapper">

                                    <Dropdown2 err={myclasserr == "err" ? "err" : ""} func={drpfuncClass} myplaceholder=" " fontsize="16" fontfamily="'Poppins', sans-serif" options={optionsnoticefor} />
                                </div>
                                <label>{labelmyclass}</label>
                            </div>
                        </div>
                        </Col>
                        <Col lg={4}  xs={6} className="pr5">
                              <div className="basicinput">

                                  <p>Section</p>
                                  <div className="inputgap h35p mbp">
                                      <div className="dropdownwrapper">
                                          <Dropdown2 err={sectionerr} func={drpfuncsection} myplaceholder=" " fontsize="12" fontfamily="'Poppins', sans-serif" options={optionssection} />
                                      </div>
                                      <label>{labelsection}</label>
                                  </div>
                              </div>
                              
                        </Col>
                        <Col lg={4} xs={6} className="pl5">
                              <div className="basicinput">

                                  <p>Shift</p>
                                  <div className="inputgap h35p mbp">
                                      <div className="dropdownwrapper">
                                          <Dropdown2 err={shifterr} func={drpfuncshift} myplaceholder=" " fontsize="12" fontfamily="'Poppins', sans-serif" options={optionssection} />
                                      </div>
                                      <label>{labelshift}</label>
                                  </div>
                              </div>
                              
                        </Col>
                        
                        <Col lg={12}>
                        <div className="basicinput ">
                            <p>Title</p>
                            <div className="inputgap h35p mbp">
                                <div className="dropdownwrapper">

                                <input style={titlemod1err=="err"?{border:"1px solid #ed1c24"}:{}} type="text" value={titlemod1} onChange={handletitlemod1}/>
                                </div>
                                <label>{labeltitlemod1}</label>
                            </div>
                        </div>
                        </Col>

                        <Col lg={12}>
                            <div className="basicinput modalinputgap">
                                <p>HTML Body</p>
                                <div className="inputgap h35p mbp" style={descriptionmod1err=="err"?{border:"1px solid #ed1c24", borderRadius:"10px"}:{}}>
                                    <div style={{ hieght: "150px", border: "1px solid rgba(0,0,0,0.2)", borderRadius: "10px" }}>
                                        <Editor
                                            editorState={editorState}
                                            wrapperClassName="demo-wrapper"
                                            editorClassName="demo-editor"
                                            onEditorStateChange={onEditorStateChange}
                                        />
                                    </div>
                                    <label>{descriptionmod1label}</label>

                                </div>
                            </div>
                        </Col>
                        <Col lg={6} xs={6} className="pr5">
                              <div className="basicinput">

                                  <p>Publish</p>
                                  <div className="inputgap h35p mbp">
                                      <div className="dropdownwrapper">
                                          <Dropdown2 err={publishmod1err} func={handlepublishmod1} myplaceholder=" " fontsize="12" fontfamily="'Poppins', sans-serif" options={optionspublish} />
                                      </div>
                                      <label>{labelpublishmod1}</label>
                                  </div>
                              </div>
                              
                        </Col>
                        <Col lg={6} xs={6} className="pl5">
                              <div className="basicinput">

                                  <p>Tailor</p>
                                  <div className="inputgap h35p mbp">
                                      <div className="dropdownwrapper">
                                          <Dropdown2 err={tailormod1err} func={handletailormod1} myplaceholder=" " fontsize="12" fontfamily="'Poppins', sans-serif" options={optionstailor} />
                                      </div>
                                      <label>{labeltailormod1}</label>
                                  </div>
                              </div>
                              
                        </Col>
                        <Col lg={6} xs={6} className="pr5">
                              <div className="basicinput">

                                  <p>Checked By</p>
                                  <div className="inputgap h35p mbp">
                                      <div className="dropdownwrapper">
                                          <Dropdown2 err={checkedbymod1err} func={handlecheckedbymod1} myplaceholder=" " fontsize="12" fontfamily="'Poppins', sans-serif" options={optionscheckedby} />
                                      </div>
                                      <label>{labelcheckedbymod1}</label>
                                  </div>
                              </div>
                              
                        </Col>
                        <Col lg={6} xs={6} className="pl5">
                              <div className="basicinput">

                                  <p>Ordered By</p>
                                  <div className="inputgap h35p mbp">
                                      <div className="dropdownwrapper">
                                          <Dropdown2 err={orderedbymod1err} func={handleorderedbymod1} myplaceholder=" " fontsize="12" fontfamily="'Poppins', sans-serif" options={optionscheckedby} />
                                      </div>
                                      <label>{labelorderedbymod1}</label>
                                  </div>
                              </div>
                              
                        </Col>
                    
                        <Col lg={6} xs={6} className="pr5">
                  <div className="basicinput modalinputgap">
                    <p>Active from</p>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <div className="inputgap h35p mbp">
                      <DatePicker
                          
                          value={activefromModal1}
                          onChange={(newvaldob)=>handleActiveFromModal1(newvaldob)}
                          renderInput={(params) => <TextField style={activefromModal1err=="err"?{border:"1px solid #ed1c24",borderRadius:"10px"}:{}} {...params}inputProps={{
                              ...params.inputProps,
                              placeholder: "Active From"
                            }} error={false} />}
                      />
                      <label>{activefromModal1label}</label>
                      </div>
                    </LocalizationProvider>
                  </div>
                </Col>
                        <Col lg={6} xs={6} className="pl5">
                        <div className="basicinput">
                            <p>Active To</p>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <div className="inputgap h35p mbp">
                                    <DatePicker

                                        value={activetoModal1}
                                        onChange={(newvaldob) => handleActivetoModal1(newvaldob)}
                                        renderInput={(params) => <TextField style={activetoModal1err == "err" ? { border: "1px solid #ed1c24", borderRadius: "10px" } : {}} {...params} inputProps={{
                                            ...params.inputProps,
                                            placeholder: "Active To"
                                        }} error={false} />}
                                    />
                                    <label>{activetoModal1label}</label>
                                </div>
                            </LocalizationProvider>
                        </div>
                        </Col>
                        <Col lg={6} xs={6} className="pr5">
                        <div className="basicinput">

                            <p>Sesison</p>
                            <div className="inputgap mbp h35p">
                                <div className="dropdownwrapper">
                                    <Dropdown2 err={sessionmod1err} func={handlesessionmod1} myplaceholder=" " fontsize="12" fontfamily="'Poppins', sans-serif" options={optionssession} />
                                </div>
                                <label>{labelsessionmod1}</label>
                            </div>
                        </div>
                              
                        </Col>
                       
                      </Row>
                   
                    </Col>
                    
                  </Row>

                </Modal.Body>
                <Modal.Footer className="m-auto" style={{borderTop:"0"}}>
                  <button variant="secondary" type="button" onClick={handleClose}>
                    Close
                  </button>
                  <button variant="primary" onClick={handlesaveModal1}>
                    Save
                  </button>
                </Modal.Footer>

                
              </Modal>

                {/* modal2ori */}
              <Modal dialogClassName="mymodalmenueid" show={show3} onHide={handleClose2} backdrop="static"
              keyboard={false}>
                <Modal.Header closeButton>
                  <Modal.Title className="ms-auto">Class Subject</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                <Row>
    <Col lg={10} className="m-auto">
    <Row>
        <Col lg={4} xs={6} className="pr5">
            <div className="basicinput modalinputgap">
                <p>Notice Date</p>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <div className="inputgap h35p mbp">
                        <DatePicker

                            value={noticedatemod2}
                            onChange={(newvaldob) => handlenoticedatemod2(newvaldob)}
                            renderInput={(params) => <TextField style={noticedatemod2err == "err" ? { border: "1px solid #ed1c24", borderRadius: "10px" } : {}} {...params} inputProps={{
                                ...params.inputProps,
                                placeholder: " "
                            }} error={false} />}
                        />
                        <label>{labelnoticedatemod2}</label>
                    </div>
                </LocalizationProvider>
            </div>
        </Col>
        <Col lg={4} xs={6} className="pl5">
        <div className="basicinput ">
            <p>Notice Type</p>
            <div className="inputgap  h35p mbp">
                <div className="dropdownwrapper">

                    <Dropdown2 err={noticetypeerr2 == "err" ? "err" : ""} func={drpfuncnoticetype2} myplaceholder=" " fontsize="16" fontfamily="'Poppins', sans-serif" options={optionsnoticetype} />
                </div>
                <label>{noticetypelabel2}</label>
            </div>
        </div>
        </Col>
        <Col lg={4} xs={6} className="pr5">
        <div className="basicinput ">
            <p>Notice For</p>
            <div className="inputgap h35p mbp">
                <div className="dropdownwrapper">

                    <Dropdown2 err={noticeforerr2 == "err" ? "err" : ""} func={drpfuncnoticefor2} myplaceholder=" " fontsize="16" fontfamily="'Poppins', sans-serif" options={optionsnoticefor} />
                </div>
                <label>{noticeforlabel2}</label>
            </div>
        </div>
        </Col>
        <Col lg={4} xs={6} className="pl5">
        <div className="basicinput ">
            <p>Class</p>
            <div className="inputgap h35p mbp">
                <div className="dropdownwrapper">

                    <Dropdown2 err={classmod2err == "err" ? "err" : ""} func={drpfuncclassmod2} myplaceholder=" " fontsize="16" fontfamily="'Poppins', sans-serif" options={optionsnoticefor} />
                </div>
                <label>{labelmyclassmod2}</label>
            </div>
        </div>
        </Col>
        <Col lg={4} xs={6} className="pr5">
              <div className="basicinput">

                  <p>Section</p>
                  <div className="inputgap h35p mbp">
                      <div className="dropdownwrapper">
                          <Dropdown2 err={sectionmod2err} func={drpfuncsectionmod2} myplaceholder=" " fontsize="12" fontfamily="'Poppins', sans-serif" options={optionssection} />
                      </div>
                      <label>{labelsectionmod2}</label>
                  </div>
              </div>
              
        </Col>
        <Col lg={4} xs={6} className="pl5">
              <div className="basicinput">

                  <p>Shift</p>
                  <div className="inputgap h35p mbp">
                      <div className="dropdownwrapper">
                          <Dropdown2 err={shifterrmod2} func={drpfuncshiftmod2} myplaceholder=" " fontsize="12" fontfamily="'Poppins', sans-serif" options={optionssection} />
                      </div>
                      <label>{labelshiftmod2}</label>
                  </div>
              </div>
              
        </Col>
        
        <Col lg={12}>
        <div className="basicinput modalinputgap">
            <p>Title</p>
            <div className="inputgap h35p mbp">
                <div className="dropdownwrapper">

                <input style={titlemod2err=="err"?{border:"1px solid #ed1c24"}:{}} type="text" value={titlemod2} onChange={handletitlemod2}/>
                </div>
                <label>{labeltitlemod2}</label>
            </div>
        </div>
        </Col>

        <Col lg={12}>
            <div className="basicinput modalinputgap">
                <p>HTML Body</p>
                <div className="inputgap h35p mbp" style={descriptionmod2err=="err"?{border:"1px solid #ed1c24", borderRadius:"10px"}:{}}>
                    <div style={{ hieght: "150px", border: "1px solid rgba(0,0,0,0.2)", borderRadius: "10px" }}>
                        <Editor
                            editorState={editorStatemod2}
                            wrapperClassName="demo-wrapper"
                            editorClassName="demo-editor"
                            onEditorStateChange={onEditorStateChangemod2}
                        />
                    </div>
                    <label>{descriptionmod2label}</label>

                </div>
            </div>
        </Col>
        <Col lg={6} xs={6} className="pr5">
              <div className="basicinput">

                  <p>Publish</p>
                  <div className="inputgap h35p mbp">
                      <div className="dropdownwrapper">
                          <Dropdown2 err={publishmod2err} func={handlepublishmod2} myplaceholder=" " fontsize="12" fontfamily="'Poppins', sans-serif" options={optionspublish} />
                      </div>
                      <label>{labelpublishmod2}</label>
                  </div>
              </div>
              
        </Col>
        <Col lg={6} xs={6} className="pl5">
              <div className="basicinput">

                  <p>Tailor</p>
                  <div className="inputgap h35p mbp">
                      <div className="dropdownwrapper">
                          <Dropdown2 err={tailormod2err} func={handletailormod2} myplaceholder=" " fontsize="12" fontfamily="'Poppins', sans-serif" options={optionstailor} />
                      </div>
                      <label>{labeltailormod2}</label>
                  </div>
              </div>
              
        </Col>
        <Col lg={6} xs={6} className="pr5">
              <div className="basicinput">

                  <p>Checked By</p>
                  <div className="inputgap h35p mbp">
                      <div className="dropdownwrapper">
                          <Dropdown2 err={checkedbymod2err} func={handlecheckedbymod2} myplaceholder=" " fontsize="12" fontfamily="'Poppins', sans-serif" options={optionscheckedby} />
                      </div>
                      <label>{labelcheckedbymod2}</label>
                  </div>
              </div>
              
        </Col>
        <Col lg={6} xs={6} className="pl5">
              <div className="basicinput">

                  <p>Ordered By</p>
                  <div className="inputgap h35p mbp">
                      <div className="dropdownwrapper">
                          <Dropdown2 err={orderedbymod2err} func={handleorderedbymod2} myplaceholder=" " fontsize="12" fontfamily="'Poppins', sans-serif" options={optionscheckedby} />
                      </div>
                      <label>{labelorderedbymod2}</label>
                  </div>
              </div>
              
        </Col>
    
        <Col lg={6} xs={6} className="pr5">
            <div className="basicinput modalinputgap">
                <p>Active from</p>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                <div className="inputgap h35p mbp">
                <DatePicker
                    
                    value={activefromModal2}
                    onChange={(newvaldob)=>handleActiveFromModal2(newvaldob)}
                    renderInput={(params) => <TextField style={activefromModal2err=="err"?{border:"1px solid #ed1c24",borderRadius:"10px"}:{}} {...params}inputProps={{
                        ...params.inputProps,
                        placeholder: "Active From"
                        }} error={false} />}
                />
                <label>{activefromModal2label}</label>
                </div>
                </LocalizationProvider>
            </div>
            </Col>
                    <Col lg={6} xs={6} className="pl5">
                    <div className="basicinput">
                        <p>Active To</p>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <div className="inputgap h35p mbp">
                                <DatePicker

                                    value={activetoModal2}
                                    onChange={(newvaldob) => handleActiveToModal2(newvaldob)}
                                    renderInput={(params) => <TextField style={activetoModal2err == "err" ? { border: "1px solid #ed1c24", borderRadius: "10px" } : {}} {...params} inputProps={{
                                        ...params.inputProps,
                                        placeholder: "Active To"
                                    }} error={false} />}
                                />
                                <label>{activetoModal2label}</label>
                            </div>
                        </LocalizationProvider>
                    </div>
                    </Col>
                    <Col lg={6} xs={6} className="pr7">
                    <div className="basicinput">

                        <p>Sesison</p>
                        <div className="inputgap h35p mbp">
                            <div className="dropdownwrapper">
                                <Dropdown2 err={sessionmod2err} func={handlesessionmod2} myplaceholder=" " fontsize="12" fontfamily="'Poppins', sans-serif" options={optionssession} />
                            </div>
                            <label>{labelsessionmod2}</label>
                        </div>
                    </div>
                        
                    </Col>
                
                </Row>
            
                </Col>
                
            </Row>

                </Modal.Body>
                <Modal.Footer className="m-auto" style={{borderTop:"0"}}>
                  <button variant="secondary" type="button" onClick={handleClose3}>
                    Close
                  </button>
                  <button variant="primary" onClick={handlesaveModal2}>
                    Update
                  </button>
                </Modal.Footer>
              </Modal>
            </div>
        </div>
    </div>
    </>
  )
}

export default NoticeCompAdmb